export default __webpack_public_path__ + "static/media/icon-views.6c4f1236.svg";